import { createI18n } from "vue-i18n";

const messages = {
  en: {
    age_check: {
      // Age Check
      header: "SHOT MACHINE",
      message: "Are you 18 or older?",
      day: "Day",
      month: "Month",
      year: "Year",
      enter_birthday: "We attach great importance to the responsible use of alcohol. \n You must therefore be of legal age to visit this site.",
      day_placeholder: "DD",
      month_placeholder: "MM",
      year_placeholder: "YYYY",
      how_many_people: "How many people will be playing?",
      person: "person",
      people: "people",
      confirm_button: "yes",
      play_button: "Play",
      reject_button: "no",
      legal_conditions: "Privacy policy + Legal conditions",
      // age check erros
      error_day_message: "Please enter a valid day",
      error_month_message: "Please enter a valid month",
      error_year_message: "Please enter a valid year",
    },
    age_check_failed: {
      failed_header: "WE ARE SORRY!",
      failed_subheader: "THAT'S A SHAME",
      failed_content: "Unfortunately, you do not fulfil the legal drinking age and therefore cannot take part in this game.",
      legal_conditions: "Privacy policy + Legal conditions",
    },
    legal_acceptance: {
      title: "Legal conditions",
      description:
        "Before you continue to the game, please read and accept the privacy policy and legal conditions.",
      checkbox_prefix: "I have read and accept:",
      checkbox_link: "privacy policy and legal conditions",
      continue_button: "Continue",
      back_button: "Back",
    },
    image_slider: {
      thats_enough: "That's enough for today.",
      thanks_for_playing: "Thanks for playing!",
      loading: "Loading...",
      please_wait: "Please wait...",
    },
    thats_enough: {
      thats_enough: "That's it for today!",
      thanks_for_playing: "You're welcome to play again tomorrow for a rematch.",
    },
    photo_capture: {
      title: "Take your shot",
      description:
        "Take a quick selfie after the game. You will share it on Instagram, show it to the bartender and then enter the raffle for the chance to win a prize.",
      placeholder: "Ready for a selfie",
      open_camera: "Open camera",
      capture_photo: "Take photo",
      retake_photo: "Retake photo",
      skip: "Skip",
      continue: "Continue",
    },
    game_controls: {
      got_it: "Got it",
      play_again: "Play again",
      push_for_your_move: "Push for your move",
      back: "Back",
    },
    share_instructions: {
      title: "Share your shot",
      description: "",
      steps:
        "Tap Share on Instagram, pick Instagram from the share sheet and post your image there for the chance to win a prize.",
      bartender_note:
        "Before the raffle, show your shared Instagram story or post to the bartender, then come back here.",
      share_button: "Share on Instagram",
      sharing: "Preparing share...",
      back_button: "Back",
    },
    raffle: {
      title: "Bonus raffle",
      description: "Back from Instagram? Give the wheel one more spin for a chance to win.",
      idle_title: "Start the raffle",
      idle_subtitle: "Tap below to reveal your result",
      prize_label: "Prize",
      live_badge: "Live validation",
      live_instruction: "Show this live screen to the bartender.",
      live_code_label: "Verification code",
      start_button: "Start raffle",
      stop_button: "Stop raffle",
      loading_button: "Loading result...",
      finish_button: "Continue",
    },
  },
  de: {
    age_check: {
      // Age Check
      header: "SHOT MACHINE",
      message: "Bist du 18 Jahre oder älter?",
      day: "Tag",
      month: "Monat",
      year: "Jahr",
      enter_birthday: "Wir legen großen Wert auf den verantwortungsbewussten Umgang mit Alkohol. \n Du musst daher volljährig sein, um diese Seite besuchen zu dürfen.",
      day_placeholder: "TT",
      month_placeholder: "MM",
      year_placeholder: "JJJJ",
      how_many_people: "Wie viele Personen spielen mit?",
      person: "Person",
      people: "Personen",
      confirm_button: "ja",
      play_button: "Spielen",
      reject_button: "nein",
      legal_conditions: "Datenschutz + Rechtliche Hinweise",
      // age check erros
      error_day_message: "Bitte gib einen gültigen Tag ein",
      error_month_message: "Bitte gib einen gültigen Monat ein",
      error_year_message: "Bitte gib ein gültiges Jahr ein",
    },
    age_check_failed: {
      failed_header: "ES TUT UNS LEID!",
      failed_subheader: "DAS IST SCHADE",
      failed_content: "Leider erfüllst du nicht das gesetzliche Mindestalter zum Konsum von Alkohol und kannst daher nicht an diesem Spiel teilnehmen.",
      legal_conditions: "Datenschutz + Rechtliche Hinweise",
    },
    legal_acceptance: {
      title: "Rechtliche Hinweise",
      description:
        "Bevor du mit dem Spiel fortfährst, lies und akzeptiere bitte die Datenschutzhinweise und rechtlichen Bedingungen.",
      checkbox_prefix: "Ich habe gelesen und akzeptiere:",
      checkbox_link: "Datenschutzhinweise und rechtlichen Bedingungen",
      continue_button: "Weiter",
      back_button: "Zurück",
    },
    image_slider: {
      thats_enough: "Das reicht für heute.",
      thanks_for_playing: "Danke für's Spielen!",
      loading: "Laden...",
      please_wait: "Bitte warten...",
    },
    thats_enough: {
      thats_enough: "Das reicht für heute",
      thanks_for_playing: "Du kannst gerne morgen wieder Spielen.",
    },
    photo_capture: {
      title: "Mach dein Foto",
      description:
        "Mach nach dem Spiel schnell ein Selfie. Du teilst es danach auf Instagram, zeigst es dem Bartender und nimmst dann an der Verlosung teil, um die Chance auf einen Gewinn zu haben.",
      placeholder: "Bereit für dein Selfie",
      open_camera: "Kamera öffnen",
      capture_photo: "Foto machen",
      retake_photo: "Foto neu machen",
      skip: "Überspringen",
      continue: "Weiter",
    },
    game_controls: {
      got_it: "Verstanden",
      play_again: "Nochmal spielen",
      push_for_your_move: "Drück für deinen Move",
      back: "Zurück",
    },
    share_instructions: {
      title: "Teile dein Bild",
      description: "",
      steps:
        "Tippe auf Instagram teilen, wähle Instagram im Teilen-Menü aus und poste dort dein Bild, um die Chance auf einen Gewinn zu haben.",
      bartender_note:
        "Bevor du an der Verlosung teilnimmst, zeige deine geteilte Instagram-Story oder deinen Beitrag dem Bartender und komm dann wieder hierher zurück.",
      share_button: "Auf Instagram teilen",
      sharing: "Teilen wird vorbereitet...",
      back_button: "Zurück",
    },
    raffle: {
      title: "Bonus raffle",
      description: "Zurück von Instagram? Dreh noch einmal und sichere dir mit etwas Glück einen Preis.",
      idle_title: "Raffle starten",
      idle_subtitle: "Tippe unten, um dein Ergebnis zu sehen",
      prize_label: "Gewinn",
      live_badge: "Live-Prüfung",
      live_instruction: "Zeige diesen Live-Screen dem Bartender.",
      live_code_label: "Prüfcode",
      start_button: "Raffle starten",
      stop_button: "Raffle stoppen",
      loading_button: "Ergebnis wird geladen...",
      finish_button: "Weiter",
    },
  },
  hu: {
    age_check: {
      header: "SHOT MACHINE",
      message: "Elmúltál már 18 éves?",
      day: "Nap",
      month: "Hónap",
      year: "Év",
      enter_birthday:
        "Nagy hangsúlyt fektetünk a felelős alkoholfogyasztásra. \n Ezért a weboldal megtekintéséhez nagykorúnak kell lenned.",
      day_placeholder: "NN",
      month_placeholder: "HH",
      year_placeholder: "ÉÉÉÉ",
      how_many_people: "Hányan fognak játszani?",
      person: "személy",
      people: "személy",
      confirm_button: "igen",
      play_button: "Játék",
      reject_button: "nem",
      legal_conditions: "Adatvédelem + Jogi tudnivalók",
      error_day_message: "Kérjük, adj meg egy érvényes napot",
      error_month_message: "Kérjük, adj meg egy érvényes hónapot",
      error_year_message: "Kérjük, adj meg egy érvényes évet",
    },
    age_check_failed: {
      failed_header: "SAJNÁLJUK!",
      failed_subheader: "EZ KÁR",
      failed_content:
        "Sajnos nem felelsz meg az alkoholfogyasztás törvényi korhatárának, ezért nem vehetsz részt ebben a játékban.",
      legal_conditions: "Adatvédelem + Jogi tudnivalók",
    },
    legal_acceptance: {
      title: "Jogi tudnivalók",
      description:
        "Mielőtt továbblépsz a játékhoz, kérjük, olvasd el és fogadd el az adatvédelmi tájékoztatót és a részvételi feltételeket.",
      checkbox_prefix: "Elolvastam és elfogadom:",
      checkbox_link: "Adatvédelmi tájékoztató és részvételi feltételek",
      continue_button: "Tovább",
      back_button: "Vissza",
    },
    image_slider: {
      thats_enough: "Mára ennyi elég.",
      thanks_for_playing: "Köszönjük, hogy játszottál!",
      loading: "Betöltés...",
      please_wait: "Kérjük, várj...",
    },
    thats_enough: {
      thats_enough: "Mára ennyi volt",
      thanks_for_playing: "Holnap újra játszhatsz egy visszavágót.",
    },
    photo_capture: {
      title: "Készíts egy fotót",
      description:
        "Készíts gyorsan egy szelfit a játék után! Ezután oszd meg Instagramon, majd mutasd meg a bartendernek! Ezzel részt veszel a sorsoláson, mellyel nyereményeket nyerhetsz.",
      placeholder: "Készen állsz egy szelfire",
      open_camera: "Kamera megnyitása",
      capture_photo: "Fotó készítése",
      retake_photo: "Fotó újrakészítése",
      skip: "Kihagyás",
      continue: "Tovább",
    },
    game_controls: {
      got_it: "Rendben",
      play_again: "Játssz újra",
      push_for_your_move: "Következő lépés",
      back: "Vissza",
    },
    share_instructions: {
      title: "Oszd meg a képed!",
      description: "",
      steps:
        "Koppints az Instagram megosztásra, válaszd ki az Instagramot a megosztási menüből, és posztold ott a képedet a nyereményjátékban való részvételért!",
      bartender_note:
        "A sorsolás előtt mutasd meg a megosztott Instagram-sztorit vagy posztot a bartendernek, majd gyere vissza ide!",
      share_button: "Megosztás Instagramon",
      sharing: "Megosztás előkészítése...",
      back_button: "Vissza",
    },
    raffle: {
      title: "Extra sorsolás!",
      description:
        "Visszatértél az Instagramról? Pörgesd meg még egyszer a kereket, és nyerj egy díjat!",
      idle_title: "Indítsd a sorsolást!",
      idle_subtitle: "Koppints lent az eredmény megjelenítéséhez!",
      prize_label: "Nyeremény",
      live_badge: "Élő ellenőrzés",
      live_instruction: "Mutasd meg ezt az élő képernyőt a bartendernek.",
      live_code_label: "Ellenőrző kód",
      start_button: "Sorsolás indítása",
      stop_button: "Sorsolás megállítása",
      loading_button: "Eredmény betöltése...",
      finish_button: "Tovább",
    },
  },
};
const i18n = createI18n({
  locale: "en",
  legacy: true,
  fallbackLocale: "en",
  messages,
});

export default i18n;
